<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">充值档次</div>
    </div>
    <div class="nav2">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openAdd">添加</el-button>
      <el-table :data="tableData" style="margin-top: 16px" v-loading="loading">
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="amount" label="金额（元）"></el-table-column>
        <el-table-column label="启用">
          <template slot-scope="scope">{{ scope.row.enabled == 1 ? "启用" : "停用" }}</template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="form.id ? '编辑充值档次' : '添加充值档次'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="form.name" size="small" placeholder="如 10元"></el-input>
        </el-form-item>
        <el-form-item label="金额">
          <el-input v-model="form.amount" size="small" placeholder="整数元"></el-input>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      visible: false,
      form: { id: null, name: "", amount: "", enabled: 1 }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    rowsOf(res) {
      const body = res && res.data ? res.data : {};
      return body.data || [];
    },
    async getData() {
      this.loading = true;
      const res = await this.$api.crudselectListByMap({
        page: 1,
        pagesize: 500,
        table: "recharge_tier",
        params: {}
      });
      const rows = this.rowsOf(res);
      rows.sort((a, b) => {
        const diff = Number(a.amount) - Number(b.amount);
        return diff !== 0 ? diff : Number(a.id) - Number(b.id);
      });
      this.tableData = rows;
      this.loading = false;
    },
    openAdd() {
      this.form = { id: null, name: "", amount: "", enabled: 1 };
      this.visible = true;
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        amount: row.amount,
        enabled: Number(row.enabled)
      };
      this.visible = true;
    },
    async save() {
      if (!this.form.name || !/^[1-9]\d*$/.test(String(this.form.amount))) {
        this.$message.error("名称必填，金额须为正整数");
        return;
      }
      const values = {
        name: this.form.name,
        amount: Number(this.form.amount),
        enabled: this.form.enabled
      };
      const res = this.form.id
        ? await this.$api.crudupdatebyid({ table: "recharge_tier", id: this.form.id, values })
        : await this.$api.crudInsert({ table: "recharge_tier", values });
      if (res.data && res.data.result == 1) {
        this.$message.success("保存成功");
        this.visible = false;
        this.getData();
      } else {
        this.$message.error((res.data && res.data.msg) || "保存失败");
      }
    },
    async remove(row) {
      await this.$confirm("确认删除该充值档次？", "提示", { type: "warning" });
      const res = await this.$api.crudDeletebyid({ table: "recharge_tier", id: row.id });
      if (res.data && res.data.result == 1) {
        this.$message.success("已删除");
        this.getData();
      } else {
        this.$message.error((res.data && res.data.msg) || "删除失败");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;
  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
  }
}
.nav2 {
  background: #fff;
  margin: 16px 0;
  padding: 20px;
}
</style>
